
    import { paintLoaderSnail } from "./render/toon/overlays/loader-snail.js";
    paintLoaderSnail(document.querySelector("#gameLoader .game-loader__snail"));
  